export const LOGIN_INFO = "LOGIN_INFO"
export const CASE_DETAIL = "CASE_DETAIL"
export const APP_DETAIL = "APP_DETAIL"
export const GROUP_DETAIL = "GROUP_DETAIL"
export const SIDE_CHECK = "SIDE_CHECK"
export const SCENE_CHECK = "SCENE_CHECK"
export const LOGIN_FORWARD_PATH = "LOGIN_FORWARD_PATH"
export const EXTRANET_IP = "EXTRANET_IP"
export const WEB_IP = "WEB_IP"
export const ENABLE_PHONE_MODEL = "ENABLE_PHONE_MODEL"
export const FUN = "FUN"
export const CHANGE_FUN = "CHANGE_FUN"
export const GUIDE = "GUIDE"
export const MANAGE = "MANAGE"
export const LOGIN_TIMEOUT = "LOGIN_TIMEOUT"
export const LOGIN_ERROR = "LOGIN_ERROR"
export const LOG_GROUP_ID = "LOG_GROUP_ID"
export const GROUP_DEV_SHOW_MODE = "GROUP_DEV_SHOW_MODE"
export const DEVICE_WINDOW_SHOW_MODE = "DEVICE_WINDOW_SHOW_MODE"
export const DEVICE_WINDOW_SHOW_LATEST = "DEVICE_WINDOW_SHOW_LATEST"
export const CAMERA_SHOW_MODE = "CAMERA_SHOW_MODE"
export const VIDEO_SHOW_MODE = "VIDEO_SHOW_MODE"
export const DEVICE_SYNC_SHOW_MODE = "DEVICE_SYNC_SHOW_MODE"
export const SIDE_INFO = "SIDE_INFO"
export const IS_ADMIN_ROOT = "IS_ADMIN_ROOT"
export const IS_ADMIN = "IS_ADMIN"
export const IS_NEED_LAYER = "IS_NEED_LAYER"
export const IS_NEED_LICENSE = "IS_NEED_LICENSE"
export const LICENSE_UPDATE = "LICENSE_UPDATE"
export const LICENSE_SAVE = "LICENSE_SAVE"
export const VISIT_PAGE = "VISIT_PAGE"
export const HELP_INDEX = "HELP_INDEX"
export const ENABLE_IP_PROXY = "ENABLE_IP_PROXY"
export const ENABLE_CMD_FORWARD = "ENABLE_CMD_FORWARD"
export const ENABLE_CONTAINER_MIRROR = "ENABLE_CONTAINER_MIRROR"
export const ENABLE_DEV_MASTER = "ENABLE_DEV_MASTER"
export const DEV_INFO = "DEV_INFO"
export const SSH_INFO = "SSH_INFO"
export const LOGIN_NOW = "LOGIN_NOW"
export const LOGIN_STATE = "LOGIN_STATE"
export const DISPLAY_MODE = "DISPLAY_MODE"
export const SCALE_MODE = "SCALE_MODE"
export const SORT_MODE = "SORT_MODE"
export const REFRESH_TIME = "REFRESH_TIME"
export const FILE_RECORD_ID = "FILE_RECORD_ID"
export const FILE_ISSUE_INFO = "FILE_ISSUE_INFO"
export const DISPLAY_SIDE = "DISPLAY_SIDE"
export const MIRROR_RECORD = "MIRROR_RECORD"
export const SET_IS_MOBILE = "SET_IS_MOBILE"